import {AppState} from '../../../reducers/index';
import {createSelector} from '@ngrx/store';
import * as fromFillableFormReducer from './fillable-form.reducer';
import {truncateString} from "../../../../interfaces/global.interface";

export const currentState = (state: AppState) => (state[fromFillableFormReducer.fillableFormsFeatureKey]);

export const selectAllFillableForms = createSelector(currentState, fromFillableFormReducer.selectAll);

export const selectTotalFillableForms = createSelector(currentState, fromFillableFormReducer.selectTotal);

export const selectModifiedFillableForms = createSelector(selectAllFillableForms, (fillableForms) => {
  return fillableForms.map((fillableForm) => {
    return {
      ...fillableForm,
      modService: fillableForm?.service?.serviceName,
    };
  });
});

export const selectModifiedFillableFormByUid= (uniqueId) => createSelector(selectAllFillableForms, (fillableForms) => {
  return fillableForms.find((fillableForm) => fillableForm.uniqueId === uniqueId);
});

